export default function (entry) {
	return this.html.tag('ul', {class: this.html.classes('field__errors')}, {fieldErrors: ''}, '');
}
